import React from "react";

import {OptionalContent} from "../../../components/OptionalContent";
import {useHome} from "./HomeContext";
import {useHomeAction} from "./HomeActionContext";
import FormCreateApartment from "./FormCreateApartment";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import List from "@mui/material/List";
import Avatar from "@mui/material/Avatar";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";



const HomeApartmentList = () => {
    const {apartments} = useHome();
    const {handleApartmentSelection, formCreateApartment} = useHomeAction();

    const apartmentSummaryTest = (apartment) => {
        const {mq, beds, sofaBeds, extraBeds} = apartment;
        let text =  `${mq ? mq : '-'} mq, ${beds} letti`;
        if(sofaBeds) {
            text += `, ${sofaBeds} divano letti`;
        }
        if(extraBeds) {
            text += `, ${extraBeds} letti extra`;
        }
        return text;
    }

    return <Card sx={{mt: 3}}>
        <CardHeader title="Appartamenti"
                    titleTypographyProps={{color: "primary.main", variant: 'button'}}
                    sx={{pb:0}}
                    action={
                        <Button onClick={formCreateApartment.open} endIcon={<AddIcon/>}>
                            Nuovo
                        </Button>
                    }/>
        <OptionalContent hasContent={apartments.length > 0} showIcon noContentMessage={"Nessun appartamento presente"}>
            <List>
                {
                    apartments.map((a, i) => (
                        <ListItem key={i} disablePadding>
                            <ListItemButton onClick={() => handleApartmentSelection(a.id)}>
                                <ListItemAvatar>
                                    <Avatar variant='rounded' src={a.icon} alt={a.name}>
                                        {a.name ? a.name.charAt(0) : "A"}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={a.name}
                                              secondary={apartmentSummaryTest(a)}/>
                                <EditIcon fontSize="small"/>
                            </ListItemButton>
                        </ListItem>
                    ))
                }
            </List>
        </OptionalContent>

        {
            formCreateApartment.show && <FormCreateApartment/>
        }
    </Card>
}

export default HomeApartmentList;